// ---- Card Lookup (handles x-modal appended to body) ----

function kmFindCard(el) {
  const card = el.closest('product-card');
  if (card) return card;
  const modal = el.closest('[data-card-id]');
  return modal ? document.getElementById(modal.dataset.cardId) : null;
}

function kmFindModal(card) {
  if (!card || !card.id) return null;
  return document.querySelector(`[data-card-id="${card.id}"]`);
}

// ---- Wishlist ----

function kmGetWishlistData() {
  try {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  } catch (e) {
    return [];
  }
}

function kmSaveWishlistData(wishlistData) {
  localStorage.setItem('wishlist', JSON.stringify(wishlistData));
  document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: wishlistData.length } }));
}

function kmWishlistItemKey(item) {
  return String(item.productId || item.productUrl || item.productTitle || '');
}

function kmWishlistHasItem(wishlistData, itemData) {
  const itemKey = kmWishlistItemKey(itemData);
  if (!itemKey) return false;

  return wishlistData.some(item => kmWishlistItemKey(item) === itemKey);
}

function kmWishlistDataFromElement(el) {
  return {
    productId: el.dataset.productId || '',
    productTitle: el.dataset.productTitle || '',
    productImg: el.dataset.productImg || '',
    productPrice: el.dataset.productPrice || '',
    productComparePrice: el.dataset.productComparePrice || '',
    productUrl: el.dataset.productUrl || '',
  };
}

function kmCopyWishlistData(target, source) {
  if (!target || !source) return;

  ['productId', 'productTitle', 'productImg', 'productPrice', 'productComparePrice', 'productUrl'].forEach(key => {
    if (source.dataset[key] !== undefined) target.dataset[key] = source.dataset[key];
  });

  if (target.dataset.productTitle) {
    target.setAttribute('aria-label', `${target.getAttribute('aria-pressed') === 'true' ? 'Remove' : 'Add'} ${target.dataset.productTitle} ${target.getAttribute('aria-pressed') === 'true' ? 'from' : 'to'} wishlist`);
  }
}

function kmUpdateWishlistButtonState(button) {
  if (!button) return;

  const itemData = kmWishlistDataFromElement(button);
  const isActive = kmWishlistHasItem(kmGetWishlistData(), itemData);
  button.classList.toggle('is-active', isActive);
  button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  button.setAttribute('aria-label', `${isActive ? 'Remove' : 'Add'} ${itemData.productTitle || 'product'} ${isActive ? 'from' : 'to'} wishlist`);
}

function kmUpdateWishlistButtons(card, sourceSwatch) {
  if (!card) return;

  const activeSwatch = sourceSwatch || card.querySelector('.product-card__info .km-card-custom-color-option-img.current') || card.querySelector('.km-card-custom-color-option-img.current');
  card.querySelectorAll('.km-product-card-wishlist-button').forEach(button => {
    if (activeSwatch) kmCopyWishlistData(button, activeSwatch);
    kmUpdateWishlistButtonState(button);
  });
}

function kmToggleCardWishlist(button) {
  const itemData = kmWishlistDataFromElement(button);
  if (!itemData.productTitle) return;

  let wishlistData = kmGetWishlistData();
  const isActive = kmWishlistHasItem(wishlistData, itemData);

  if (isActive) {
    const itemKey = kmWishlistItemKey(itemData);
    wishlistData = wishlistData.filter(item => kmWishlistItemKey(item) !== itemKey);
  } else {
    wishlistData.push(itemData);
  }

  kmSaveWishlistData(wishlistData);
  kmUpdateWishlistButtons(kmFindCard(button));
  displayWishlist();
}

function kmEscapeWishlistHtml(value) {
  return String(value || '').replace(/[&<>"']/g, char => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[char]));
}

function removeFromWishlist(productKey) {
  const key = String(productKey || '');
  const wishlistData = kmGetWishlistData().filter(item => {
    return kmWishlistItemKey(item) !== key && item.productTitle !== key;
  });

  kmSaveWishlistData(wishlistData);
  displayWishlist();
  document.querySelectorAll('product-card').forEach(card => kmUpdateWishlistButtons(card));
}

function displayWishlist() {
  const wishlistBlock = document.querySelector('.js-wishlistBlock');
  if (!wishlistBlock) return;

  const wishlistData = kmGetWishlistData();

  if (!wishlistData.length) {
    wishlistBlock.innerHTML = '';
    return;
  }

  wishlistBlock.innerHTML = wishlistData.map(item => {
    const productKey = kmEscapeWishlistHtml(kmWishlistItemKey(item));
    const productTitle = kmEscapeWishlistHtml(item.productTitle);
    const productImg = kmEscapeWishlistHtml(item.productImg);
    const productPrice = kmEscapeWishlistHtml(item.productPrice);
    const productComparePrice = kmEscapeWishlistHtml(item.productComparePrice);
    const productUrl = kmEscapeWishlistHtml(item.productUrl);

    return `
      <div class="wishlist-product__list">
        <div class="c-product">
          <a href="${productUrl}">
            <img src="${productImg}" alt="${productTitle}">
          </a>
          <div class="v-stack justify-items-center gap-1" style="padding-top: 24px;">
            <a href="${productUrl}" class="product-title km-product-title-link h6 line-clamp" style="--line-clamp-count: 1" data-instant="">
              ${productTitle}
            </a>
            <price-list class="price-list">
              <span class="h6 text-subdued km-wishlist-sale-price ${productComparePrice ? ` text-on-sale ` : ''}">${productPrice}</span> ${productComparePrice ? `<span class="h6 text-subdued line-through km-wishlist-compare-price">${productComparePrice}</span> ` : ''}
            </price-list>
            <button type="button" class="km-wishlist-remove-button" data-wishlist-key="${productKey}" onclick="removeFromWishlist(this.dataset.wishlistKey)">Remove</button>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

// ---- Add to Cart ----

async function kmAddToCart(btn) {
  const card = kmFindCard(btn);
  if (!card) return;

  // When called from inside x-modal (appended to body), find the sibling input
  const atcWrapper = btn.closest('.km-mobile-popup__atc, .km-card-atc-wrapper');
  const variantInput = atcWrapper
    ? atcWrapper.querySelector('.km-card-atc-variant-id')
    : card.querySelector('.km-card-atc-variant-id');
  if (!variantInput || !variantInput.value) return;

  // Cart-as-page: navigate directly
  if (window.themeVariables?.settings?.cartType === 'page') {
    window.location.href = `${Shopify.routes.root}cart/add?id=${variantInput.value}&quantity=1&return_to=/cart`;
    return;
  }

  const originalText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = 'Adding...';

  try {
    // Collect section IDs the theme wants bundled (cart-drawer registers itself here)
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    }));

    const formData = new FormData();
    formData.set('id', variantInput.value);
    formData.set('quantity', '1');
    if (sectionsToBundle.length) {
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const addResp = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });

    if (!addResp.ok) {
      const err = await addResp.json().catch(() => ({}));
      throw new Error(err.description || 'Failed to add to cart');
    }

    const addData = await addResp.json();

    // Fetch full cart data, merge in rendered sections from the add response
    const cartData = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    if (addData.sections) cartData.sections = addData.sections;

    // Trigger cart drawer open + refresh using the theme's event contract
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        onSuccessDo: 'force_open_drawer',
        cart: cartData,
      },
    }));

    btn.textContent = 'Added!';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  } catch (e) {
    console.error('[kmAddToCart]', e.message);
    btn.textContent = originalText;
    btn.disabled = false;
  }
}

// ---- Size Selection ----

function kmUpdateAtcVariant(card, variantId) {
  card.querySelectorAll('.km-card-atc-variant-id').forEach(el => { el.value = variantId; });
}

function kmSelectSize(btn) {
  const card = kmFindCard(btn);
  if (!card) return;

  card.querySelectorAll('.km-card-size-option').forEach(el => el.classList.remove('km-card-size-option--selected'));
  btn.classList.add('km-card-size-option--selected');
  kmUpdateAtcVariant(card, btn.dataset.variantId);

  // If clicking inside a detached popup (x-modal appended to body), also update popup ATC
  const detachedModal = btn.closest('[data-card-id]');
  if (detachedModal && !card.contains(detachedModal)) {
    detachedModal.querySelectorAll('.km-card-size-option').forEach(el => el.classList.remove('km-card-size-option--selected'));
    btn.classList.add('km-card-size-option--selected');
    detachedModal.querySelectorAll('.km-card-atc-variant-id').forEach(el => { el.value = btn.dataset.variantId; });
  }
}

function kmUpdateSizeOptions(card, variantsStr) {
  const variants = variantsStr
    ? variantsStr.split('|').filter(Boolean).map(v => {
        const [id, label, avail] = v.split('~');
        return { id, label, available: avail === 'true' };
      })
    : [];

  const firstAvailIdx = variants.findIndex(v => v.available);
  const selectedIdx = firstAvailIdx >= 0 ? firstAvailIdx : 0;

  // Always update ATC variant, even when no size options element is rendered
  if (variants[selectedIdx]) {
    kmUpdateAtcVariant(card, variants[selectedIdx].id);
  }

  const sizeEls = card.querySelectorAll('.km-card-size-options');
  if (!sizeEls.length) return;

  const newHtml = (!variants.length || (variants.length === 1 && variants[0].label === 'Default Title'))
    ? ''
    : variants.map((v, i) => {
        const classes = [
          'km-card-size-option',
          v.available ? '' : 'km-card-size-option--unavailable',
          i === selectedIdx ? 'km-card-size-option--selected' : '',
        ].filter(Boolean).join(' ');
        return `<button type="button" class="${classes}" data-variant-id="${v.id}" onclick="kmSelectSize(this)">${v.label}</button>`;
      }).join('');

  sizeEls.forEach(sizeEl => { sizeEl.innerHTML = newHtml; });
}

// ---- Color Switch ----

function kmSwitchColorSwiper(btn) {
  const isInPopup = !!btn.closest('[data-card-id]');
  const card = kmFindCard(btn);
  if (!card) return;

  if (isInPopup) {
    const popup = kmFindModal(card);
    if (popup) kmSwitchColorInPopup(btn, popup);
  } else {
    kmSwitchColorInCard(btn, card);
  }
}

function kmSwitchColorInCard(btn, card) {
  const figure = card.querySelector('.product-card__figure');
  const imageUrls = btn.dataset.images ? btn.dataset.images.split('|').filter(Boolean) : [];
  const productUrl = btn.dataset.productUrl || '#';

  // Update active swatch across every swatch wrapper in the card (the card can
  // render the color options twice - once in hover-actions, once in info -
  // so a click in one copy must not leave the other copy's `current` stale,
  // since kmUpdateWishlistButtons falls back to reading `current` from the
  // info copy whenever it isn't given an explicit source swatch.
  card.querySelectorAll('.km-card-custom-color-variants-wrapper .km-card-custom-color-option-img').forEach(el => {
    el.classList.toggle('current', el.dataset.productUrl === productUrl);
  });
  kmUpdateWishlistButtons(card, btn);

  if (!figure || !imageUrls.length) return;

  // Update hover swiper
  const swiperEl = figure.querySelector('.product-card__hover-swiper');
  if (swiperEl) {
    const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      swiperWrapper.innerHTML = imageUrls.slice(1).map(url =>
        `<div class="swiper-slide"><a href="${productUrl}" class="product-card__hover-swiper-link" draggable="false" tabindex="-1"><img src="${url}" alt="" class="product-card__hover-swiper-image" loading="lazy"></a></div>`
      ).join('');
      if (swiperEl.swiper) {
        swiperEl.swiper.loopDestroy();
        swiperEl.swiper.update();
        swiperEl.swiper.loopCreate();
        if (swiperEl.swiper.navigation) swiperEl.swiper.navigation.update();
        swiperEl.swiper.slideToLoop(0, 0, false);
      }
    }
  }

  // Update mobile card swiper
  const mobileSwiperEl = figure.querySelector('.product-card__mobile-swiper');
  if (mobileSwiperEl) {
    const mobileSwiperWrapper = mobileSwiperEl.querySelector('.swiper-wrapper');
    if (mobileSwiperWrapper) {
      mobileSwiperWrapper.innerHTML = imageUrls.map(url =>
        `<div class="swiper-slide"><a href="${productUrl}" class="product-card__mobile-swiper-link" draggable="false" tabindex="-1"><img src="${url}" alt="" class="product-card__mobile-swiper-image" loading="lazy"></a></div>`
      ).join('');
      if (mobileSwiperEl.swiper) {
        mobileSwiperEl.swiper.update();
        mobileSwiperEl.swiper.slideToLoop(0, 0, false);
      }
    }
  }

  // Update links and primary image
  const mediaLink = figure.querySelector('.product-card__media');
  if (mediaLink) mediaLink.href = productUrl;
  const titleLink = card.querySelector('.km-product-title-link');
  if (titleLink) titleLink.href = productUrl;
  const primaryImg = figure.querySelector('.product-card__image--primary');
  if (primaryImg && imageUrls[0]) {
    primaryImg.removeAttribute('srcset');
    primaryImg.removeAttribute('sizes');
    primaryImg.src = imageUrls[0];
  }

  // Update card size options + ATC (card DOM only)
  kmUpdateSizeOptions(card, btn.dataset.variants || '');

  // Update badges
  const badgesHtml = btn.dataset.badges || '';
  const existingBadgeList = figure.querySelector('badge-list');
  if (badgesHtml.trim()) {
    if (existingBadgeList) {
      existingBadgeList.outerHTML = badgesHtml;
    } else {
      const ml = figure.querySelector('.product-card__media');
      if (ml) ml.insertAdjacentHTML('beforebegin', badgesHtml);
    }
  } else if (existingBadgeList) {
    existingBadgeList.remove();
  }

  // Update price (card renders price-list more than once - hover-actions + info)
  const priceHtml = btn.dataset.priceHtml || '';
  if (priceHtml.trim()) {
    card.querySelectorAll('price-list').forEach(el => { el.outerHTML = priceHtml; });
  }
}

const KM_POPUP_GALLERY_MIN_LOOP_SLIDES = 6;

function kmPopupGallerySlidesHtml(imageUrls) {
  const urls = imageUrls.filter(Boolean);
  const loopUrls = [...urls];

  if (urls.length > 1) {
    while (loopUrls.length < KM_POPUP_GALLERY_MIN_LOOP_SLIDES) {
      loopUrls.push(...urls.slice(0, KM_POPUP_GALLERY_MIN_LOOP_SLIDES - loopUrls.length));
    }
  }

  return loopUrls.map(url =>
    `<div class="swiper-slide"><img src="${url}" alt="" class="km-mobile-popup__gallery-image" loading="lazy"></div>`
  ).join('');
}

function kmSwitchColorInPopup(btn, popup) {
  const imageUrls = btn.dataset.images ? btn.dataset.images.split('|').filter(Boolean) : [];
  const productUrl = btn.dataset.productUrl || '#';

  // Update active swatch in popup only
  const wrapper = btn.closest('.km-card-custom-color-variants-wrapper');
  if (wrapper) {
    wrapper.querySelectorAll('.km-card-custom-color-option-img').forEach(el => el.classList.remove('current'));
    btn.classList.add('current');
  }

  // Update popup gallery
  if (imageUrls.length) {
    const galleryEl = popup.querySelector('.km-mobile-popup__gallery');
    if (galleryEl) {
      const galleryWrapper = galleryEl.querySelector('.swiper-wrapper');
      if (galleryWrapper) {
        galleryWrapper.innerHTML = kmPopupGallerySlidesHtml(imageUrls);
        if (galleryEl.swiper) {
          const shouldLoop = imageUrls.length > 1;
          galleryEl.swiper.loopDestroy();
          galleryEl.swiper.params.loop = shouldLoop;
          galleryEl.swiper.update();
          if (shouldLoop) galleryEl.swiper.loopCreate();
          if (shouldLoop) galleryEl.swiper.slideToLoop(0, 0, false);
          else galleryEl.swiper.slideTo(0, 0, false);
        }
      }
    }
  }

  // Update View Full Details link
  const viewFull = popup.querySelector('.km-mobile-popup__view-full');
  if (viewFull) viewFull.href = productUrl;

  // Rebuild popup size options + ATC
  const variantsStr = btn.dataset.variants || '';
  const variants = variantsStr
    ? variantsStr.split('|').filter(Boolean).map(v => {
        const [id, label, avail] = v.split('~');
        return { id, label, available: avail === 'true' };
      })
    : [];
  const firstAvailIdx = variants.findIndex(v => v.available);
  const selectedIdx = firstAvailIdx >= 0 ? firstAvailIdx : 0;

  if (variants[selectedIdx]) {
    popup.querySelectorAll('.km-card-atc-variant-id').forEach(el => { el.value = variants[selectedIdx].id; });
  }

  const newHtml = (!variants.length || (variants.length === 1 && variants[0].label === 'Default Title'))
    ? ''
    : variants.map((v, i) => {
        const classes = ['km-card-size-option', v.available ? '' : 'km-card-size-option--unavailable', i === selectedIdx ? 'km-card-size-option--selected' : ''].filter(Boolean).join(' ');
        return `<button type="button" class="${classes}" data-variant-id="${v.id}" onclick="kmSelectSize(this)">${v.label}</button>`;
      }).join('');

  popup.querySelectorAll('.km-card-size-options').forEach(el => { el.innerHTML = newHtml; });

  // Update popup price
  const priceHtml = btn.dataset.priceHtml || '';
  if (priceHtml.trim()) {
    popup.querySelectorAll('price-list').forEach(el => { el.outerHTML = priceHtml; });
  }

  const card = kmFindCard(popup);
  if (card) kmUpdateWishlistButtons(card, btn);
}

// ---- Swiper Init ----

function initProductCardHoverSwipers(root) {
  (root || document).querySelectorAll('.product-card__figure').forEach(figure => {
    if (figure.dataset.hoverSwiperBound) return;
    figure.dataset.hoverSwiperBound = '1';

    const swiperEl = figure.querySelector('.product-card__hover-swiper');
    if (!swiperEl) return;

    let swiper = null;
    const card = figure.closest('product-card') || figure;

    const insideCarousel = !!card.closest('.swiper, scroll-carousel');

    card.addEventListener('mouseenter', () => {
      if (!swiper) {
        swiper = new Swiper(swiperEl, {
          loop: true,
          speed: 250,
          allowTouchMove: !insideCarousel,
          navigation: {
            prevEl: swiperEl.querySelector('.product-card__hover-swiper-prev'),
            nextEl: swiperEl.querySelector('.product-card__hover-swiper-next'),
          },
        });
      }
    });

    card.addEventListener('mouseleave', () => {
      if (swiper) swiper.slideToLoop(0, 0, false);
    });
  });
}

// ---- Grow carousel row height on hover to fit the hover-actions panel ----
// A scroll-carousel needs `overflow-y: hidden` so its native horizontal
// scroll doesn't also scroll vertically, which would otherwise clip the
// hover-actions panel bleeding below the card. Rather than reposition the
// panel, just make every card in the row tall enough (via min-height) to
// contain the tallest card's media + panel — the carousel's own height
// follows since it's a grid row sized to its tallest item, so there's
// nothing left for the clip to cut off.

function initCarouselHoverActionsHeight(root) {
  (root || document).querySelectorAll('scroll-carousel').forEach(carousel => {
    if (carousel.dataset.hoverHeightBound) return;

    const cards = Array.from(carousel.querySelectorAll('product-card'));
    if (!cards.length) return;

    // Only mark as bound once cards actually exist — if this runs while the
    // carousel is still empty (e.g. product-recommendations injects its
    // cards in a later DOM mutation), a premature flag here would make the
    // function skip the retry once cards actually show up, and this
    // carousel's height/hover wiring would silently never get set up.
    carousel.dataset.hoverHeightBound = '1';

    // These only get shown via `product-card:hover .product-card__hover-actions
    // ...` rules — real :hover can't be faked from JS, so forcing the panel
    // itself visible during measurement isn't enough; each of these still
    // renders as display:none and gets left out of the measured height.
    const HOVER_ONLY_CHILDREN = [
      ['.km-card-custom-color-variants-wrapper', 'flex'],
      ['.km-card-size-options', 'flex'],
      ['.km-card-atc-wrapper', 'block'],
    ];

    function measureExpandedHeight(card) {
      const figure = card.querySelector('.product-card__figure');
      const panel = card.querySelector('.product-card__hover-actions');
      if (!figure || !panel) return 0;

      const restoreFns = HOVER_ONLY_CHILDREN.map(([selector, display]) => {
        const el = panel.querySelector(selector);
        if (!el) return null;
        const previous = el.style.display;
        el.style.display = display;
        return () => { el.style.display = previous; };
      }).filter(Boolean);

      const previousDisplay = panel.style.display;
      panel.style.display = 'flex';

      const height = figure.getBoundingClientRect().height + panel.getBoundingClientRect().height;

      panel.style.display = previousDisplay;
      restoreFns.forEach(restore => restore());

      return height;
    }

    function applyHeight() {
      if (!window.matchMedia('(pointer: fine)').matches) return;
      const maxExpandedHeight = Math.max(...cards.map(measureExpandedHeight));
      cards.forEach(card => { card.style.minHeight = `${maxExpandedHeight}px`; });
    }

    // Reserve the tallest hovered-state height up front, on load, rather
    // than waiting for a hover to trigger it — the row is always sized to
    // fit so nothing shifts/grows when a card is actually hovered.
    applyHeight();
    window.addEventListener('resize', applyHeight);
  });
}

function watchProductRecommendations() {
  document.querySelectorAll('product-recommendations').forEach(el => {
    if (el.dataset.hoverSwiperObserved) return;
    el.dataset.hoverSwiperObserved = '1';
    new MutationObserver(() => {
      initProductCardHoverSwipers(el);
      initCarouselHoverActionsHeight(el);
    }).observe(el, { childList: true, subtree: true });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductCardHoverSwipers();
  initProductCardMobileSwipers();
  initProductCardPopups();
  initCarouselHoverActionsHeight();
  document.querySelectorAll('product-card').forEach(card => kmUpdateWishlistButtons(card));
  displayWishlist();
  watchProductRecommendations();
});
document.addEventListener('shopify:section:load', e => {
  initProductCardHoverSwipers(e.target);
  initProductCardMobileSwipers(e.target);
  initProductCardPopups(e.target);
  initCarouselHoverActionsHeight(e.target);
  e.target.querySelectorAll('product-card').forEach(card => kmUpdateWishlistButtons(card));
  displayWishlist();
  watchProductRecommendations();
});

// ---- Mobile Card Swiper (dots, touch-only) ----

function initProductCardMobileSwipers(root) {
  if (!window.matchMedia('(pointer: coarse)').matches) return;
  (root || document).querySelectorAll('.product-card__mobile-swiper').forEach(swiperEl => {
    if (swiperEl.dataset.mobileSwiperBound) return;
    swiperEl.dataset.mobileSwiperBound = '1';

    const card = swiperEl.closest('product-card') || swiperEl;
    const insideCarousel = !!card.closest('.swiper, scroll-carousel');

    new Swiper(swiperEl, {
      loop: true,
      speed: 300,
      allowTouchMove: !insideCarousel,
      pagination: {
        el: swiperEl.querySelector('.product-card__mobile-dots'),
        clickable: true,
      },
    });
  });
}

// ---- Quick View Popup (x-modal) — lazy swiper init on first open ----

function initProductCardPopups(root) {
  (root || document).querySelectorAll('x-modal.km-quick-view-modal').forEach(modal => {
    if (modal.dataset.popupListenerBound) return;
    modal.dataset.popupListenerBound = '1';

    modal.addEventListener('dialog:before-show', () => {
      // Sync color: find what's active in the card and apply to popup before it opens
      const card = document.getElementById(modal.dataset.cardId);
      if (card) {
        const activeCardSwatch = card.querySelector('.product-card__info .km-card-custom-color-option-img.current');
        if (activeCardSwatch) {
          const productUrl = activeCardSwatch.dataset.productUrl;
          const popupSwatches = modal.querySelectorAll('.km-card-custom-color-option-img');
          const popupSwatch = Array.from(popupSwatches).find(s => s.dataset.productUrl === productUrl);
          if (popupSwatch && !popupSwatch.classList.contains('current')) {
            kmSwitchColorInPopup(popupSwatch, modal);
          }
        }
      }

      // Init gallery swiper on first open (after color sync so HTML is correct)
      const galleryEl = modal.querySelector('.km-mobile-popup__gallery');
      if (galleryEl && !galleryEl.dataset.popupSwiperBound) {
        const galleryWrapper = galleryEl.querySelector('.swiper-wrapper');
        const imageUrls = galleryWrapper
          ? Array.from(galleryWrapper.querySelectorAll('.km-mobile-popup__gallery-image'))
              .map(img => img.currentSrc || img.getAttribute('src'))
              .filter(Boolean)
          : [];

        if (galleryWrapper && imageUrls.length) {
          galleryWrapper.innerHTML = kmPopupGallerySlidesHtml(imageUrls);
        }

        galleryEl.dataset.popupSwiperBound = '1';
        new Swiper(galleryEl, {
          loop: imageUrls.length > 1,
          centeredSlides: true,
          slidesPerView: 3,
          speed: 300,
          pagination: {
            el: galleryEl.querySelector('.km-mobile-popup__gallery-dots'),
            clickable: true,
          },
        });
      }
    });
  });
}